import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { LegalLinkItems } from '../legal/legalLinks';

// Неизвестный адрес: честная страница вместо лендинга под чужим URL. Нginx отдаёт SPA с 200,
// поэтому закрываем индексацию мета-тегом.
function NotFoundPage() {
  useEffect(() => {
    document.title = 'Страница не найдена — Энилекс';
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex,nofollow';
    document.head.appendChild(meta);
    return () => {
      document.head.removeChild(meta);
    };
  }, []);

  return (
    <div style={{ maxWidth: 640, margin: '10vh auto', padding: '0 16px', textAlign: 'center', lineHeight: 1.6 }}>
      <h1>Страница не найдена</h1>
      <p>Такого адреса нет. Возможно, ссылка устарела или в ней опечатка.</p>
      <p style={{ display: 'flex', gap: 16, justifyContent: 'center', flexWrap: 'wrap' }}>
        <Link to="/">На главную</Link>
        <Link to="/blog">Блог</Link>
        <Link to="/free-functions">Бесплатные инструменты</Link>
      </p>
      <nav style={{ display: 'flex', flexWrap: 'wrap', gap: '6px 16px', justifyContent: 'center', fontSize: '0.9rem' }} aria-label="Юридические документы">
        <LegalLinkItems short />
      </nav>
    </div>
  );
}

export default NotFoundPage;
